export const environmentGeneric = {
    APP_PREFIX: 'ZCI',
    ZCI_API_ENDPOINTS: {
        GET_ACCOUNT_USERS: '/api/account-permissions/accounts-users',
        GET_CLIENT_SEGMENT_TYPE: '/api/account-permissions/client-segment',
        GATEKEEPER: '/gatekeeper',
        CLIENT_LOG: '/client-log',
        GATEKEEPER_PUBLIC: '/public/gatekeeper',
        GRANT_PERMISSION_MVP: '/api/access-permissions/grant-permission-mvp',
        REMOVE_PERMISSION: '/api/access-permissions/remove-permission',
        INELIGIBLE_SCENARIOS_GRANTOR: '/api/ineligible-scenarios/grantors/eligibility',
        INELIGIBLE_SCENARIOS_GRANTEE: '/api/ineligible-scenarios/grantees/eligibility',
        INELIGIBLE_SCENARIOS_GRANTEE_IN_GRANTEE_FLOW:
            '/api/ineligible-scenarios/grantee/in-grantee-flow',
        ADD_SOMEONE_ELSE: '/api/add-someone-else/add-new-grantee',
        ADD_SOMEONE_ELSE_MULTI: '/api/access-invitations',
        AUTHENTICATE_PIN: '/api/access-permissions/authenticate-pin',
        TOKEN_VALIDATION: '/api/access-permissions/token-validation',
        TOKEN_VALIDATION_PUBLIC: '/api/access-permissions/public/token-validation',
        CHECK_PENDING_REQUEST: '/api/access-permissions/check-pending-request',
        CHECK_PENDING_REQUESTS_MULTI: '/api/access-invitations/pending-requests',
        ACCEPT_PERMISSION: '/api/access-permissions/accept-permission',
        BULK_ACCEPT_PERMISSION: '/api/access-permissions/bulk-accept',
        BULK_GRANT_PERMISSION: '/api/access-permissions/bulk-grant',
        BULK_REVOKE_PERMISSION: '/api/access-permissions/bulk-revoke',
        PUBLIC_LITE_REGISTERED_USERS_UPDATE:
            '/api/access-permissions/public/lite-registered-users/update',
        PVR_COOKIE_ENCRYPTION: '/api/access-permissions/public/pvr-cookie-encryption',
        CLEAR_LOGON_COOKIES: '/api/access-permissions/public/clear-logon-cookies',
    },
    SAIL_POINT_URL: 'https://identityiq.vanguard.com/identityiq/home.jsf',
};
